import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'
import { captureException } from '@sentry/vue'
import { isLocalEnv } from '@/util/envs.ts'
import { routes as hybridRoutes } from './routes/hybrid'
import type { Router } from 'vue-router'

const routesExtended = [...routes, ...(isLocalEnv() ? hybridRoutes : [])]

function translateHybridRoute(route: string) {
  const subroutes = route.split('/')
  const mainPageIndex = subroutes.indexOf('organization')

  const mainRoute = subroutes.slice(mainPageIndex, mainPageIndex + 3)

  mainRoute[0] = '/organizations'

  return mainRoute.join('/')
}

export let router: Router

export const getRouter = (): Router => {
  router = createRouter({
    history: createWebHistory(),
    routes: routesExtended,
  })

  // This will update routes at runtime when creating new pages without reloading the page
  if (import.meta.hot) {
    handleHotUpdate(router)
  }

  router.beforeEach((to) => {
    if (to.path.includes('/hybrid/organization')) {
      const route = translateHybridRoute(to.path)

      return {
        path: route,
        query: {
          iframe_path: to.query.iframe_path,
        },
      }
    }

    return true
  })

  // Hard-reload the page when chunk load errors match the navigation error
  // https://github.com/vitejs/vite/issues/11804#issuecomment-1760951463
  router.onError((error, to) => {
    const errors = [
      'Failed to fetch dynamically imported module',
      'Unable to preload CSS',
      'error loading dynamically imported module',
    ]

    if (errors.some((e) => error?.message?.includes(e))) {
      if (to?.fullPath) {
        window.location.href = to.fullPath
      } else {
        window.location.reload()
      }
    } else {
      captureException('Triggered automatic reload after router error. ', {
        extra: error.message,
      })
    }
  })

  return router
}
